<template>
	<div>
		<div class="upper_div"></div>
		<div class="bgImg">
			<div class="formBox">
				<div class="titleContainer">
					<h1 class="title">אתר הנדל"ן הממשלתי – {{ actionText }}</h1>
					<p class="plainText">שליחת מייל אימות</p>
				</div>
				<div
					style="
						display: table;
						width: 100%; /*Optional*/
						table-layout: fixed; /*Optional*/
						border-spacing: 5px;
					"
					class="formContainer"
				>
					<div style="display: table-cell">
						<button
							style="height: 46px; border-radius: 35px"
							@click="sendMail"
							class="btn blue"
						>
							שלח
						</button>
					</div>
					<div style="display: table-cell">
						<input
							v-model="email"
							name="emailAddress"
							class="genericInput"
							type="email"
							autocomplete="off"
							maxlength="50"
							placeholder="הזן כתובת מייל"
							value=""
						/>
					</div>
				</div>
				<div style="height: 50px"></div>
				<div
					v-if="show6Digits == true"
					style="direction: ltr"
					class="formContainer"
					autocomplete="off"
				>
					<p style="margin-top: 20px" class="plainText">
						נא להזין את המספרים שנתקבלו במייל לאימות
					</p>
					<v-otp-input
						style="margin-top: 20px"
						ref="otpInput"
						input-classes="otp-input"
						separator="-"
						:num-inputs="6"
						:should-auto-focus="true"
						:is-input-num="true"
						@on-change="handleOnChange"
						@on-complete="handleOnComplete"
					/>

					<button class="link linkUnderline" @click="handleClearInput()">
						איפוס
					</button>
				</div>
				<div style="text-align: center; height: 22px">
					<p style="color: red" class="plainText">{{ errorText }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script src="https://www.google.com/recaptcha/enterprise.js?render=6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT"></script>

<script>
export default {
	name: "App",

	data() {
		return {
			show6Digits: false,
			email: null,
			errorText: "",
			recaptchaToken: '', // Store the reCAPTCHA token here
		};
	},

	computed: {
		actionText() {
			if (this.$store.state.userTokenType == "reset") {
				return "שחזור סיסמה";
			} else if (this.$store.state.userTokenType == "verif") {
				return "אימות חשבון";
			} else {
				return "אימות";
			}
		},
	},

	methods: {
		loadRecaptchaScript() {
			// Check if the reCAPTCHA script is already added to avoid multiple loads
			if (!document.getElementById('recaptcha-script')) {
				const script = document.createElement('script');
				script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT';
				script.id = 'recaptcha-script';
				script.onload = this.onRecaptchaScriptLoaded;
				document.head.appendChild(script);
			} else {
				this.onRecaptchaScriptLoaded(); // Script already loaded, proceed
			}
		},
		onRecaptchaScriptLoaded() {
			// Once the script is loaded, initialize reCAPTCHA
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise
				.execute('6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT', { action: 'PAGE_LOAD' })
				.then((token) => {
					// Token available for any further use
					this.$store.state.recaptchaToken = token;
				});
			});
		},
		refreshRecaptcha() {
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise
				.execute('6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT', { action: 'PAGE_LOAD' })
				.then((token) => {
					// Token available for any further use
					this.$store.state.recaptchaToken = token;
				});
			});
		},
		sendMail() {
			var appVue = this;
			this.errorText = "";
			if (this.email == null || this.email == "") {
				this.errorText = "נא להזין כתובת מייל";
				return;
			}
			if (appVue.$store.state.userTokenType == null){
				appVue.$store.state.userTokenType = "verif";
			}
			//Send Token
			appVue
				.mixin_sendToken(
					appVue,
					appVue.$store.state.userTokenType,
					this.$store.state.useremail,
				)
				.then((token_res) => {
					// Do something with the result
					
					// 'הטוקן נשלח בהצלחה'
					if (token_res.statusCode == 200) {
						//if (token_res.data.message != null ) {
							this.errorText = token_res.data.message;
						//}
					} else {
						this.errorText = token_res.data.message;
						return;
					}

					// set on the local storage
					if (appVue.$store.state.userTokenType == null) {
						if (sessionStorage.userTokenType != null) {
							appVue.$store.state.userTokenType = sessionStorage.userTokenType;
						}
					}
					sessionStorage.setItem(
						"userTokenType",
						appVue.$store.state.userTokenType,
					);
					//appVue.mixin_goTo(appVue, 'approve');
					appVue.show6Digits = true;
				})
				.catch((error) => {
					console.error("error", error);
					// Handle any errors that occurred during the asynchronous operation
				});
		},
		handleOnComplete(value) {
			var appVue = this;
			
			appVue.$store.state.verifyToken = value;
			// set on localStore
			sessionStorage.verifyToken = value;
			if (appVue.$store.state.userTokenType == "reset") {
				appVue
					.mixin_verifyAccount(appVue, appVue.$store.state.useremail, value)
					.then((user_res) => {
						// Do something with the result
						
						// {
						//     "statusCode": 200,
						//     "data": {
						//         "message": "חשבון אומת בהצלחה",
						//         "userID": "9835da9d-bea9-4dd8-b154-7c2f77241e8e"
						//     }
						// }
						if (user_res.statusCode == 200) {
							if (user_res.data.message == "חשבון אומת בהצלחה") {
								appVue.$store.state.userid = user_res.data.userID;
								appVue.mixin_goTo(appVue, "reset");
							} else {
								this.errorText = user_res.data.message;
								return;
							}
							appVue.$store.state.userid = user_res.data.userID;
							appVue.mixin_goTo(appVue, "reset");
						} else {
							this.errorText = "אימות נכשל";
							return;
						}
					});
			} else if (appVue.$store.state.userTokenType == "verif") {
				appVue
					.mixin_verifyAccount(appVue, appVue.$store.state.useremail, value)
					.then((user_res) => {
						if (user_res.statusCode == 200) {
							if (user_res.data.message == "חשבון אומת בהצלחה") {
								appVue.$store.state.userid = user_res.data.userID;
								// login user
								//appVue.mixin_setCookie("user", user_res);
								// decompress user
								var decompressed = appVue.decompressBase64Gzip(appVue.mixin_getCookie("user"));
								const user = decompressed;//appVue.mixin_getCookie("user");
								if (!Object.prototype.hasOwnProperty.call(user, "addressList")) {
									user.addressList = [];
								}
								appVue.$store.state.currentUser = user;
								// console.log('currentUser',appVue.$store.state.currentUser);
								// add addressList
								//get pwd
								// get up from cookie
								var up = appVue.mixin_getCookie("up");
								// decompress up
								var decompressed = appVue.decompressBase64Gzip(up);
								const password = decompressed.pwd;
								//login user...
								appVue.mixin_login(appVue, appVue.$store.state.useremail, password)
								//remove pwd
								appVue.mixin_removeCookie("up");
								appVue.$store.state.currentUser.Verified = true;
								if (this.mixin_getCookie('user')){
									var decompessed = this.decompressBase64Gzip(this.mixin_getCookie('user'));
									const userData = decompessed;
									//change userData.Verified = true;
									userData.Verified = true;
									// add addressList
									userData.addressList = [];
									//update user in cookie
									var compressed = this.compressBase64Gzip(JSON.stringify(userData));
									this.mixin_setCookie('user', compressed );
								}
								appVue.mixin_goTo(appVue, "home");

							} else {
								alert("אימות נכשל");
								return;
							}
						} else {
							alert("אימות נכשל");
							return;
						}
					});
			} else {
				alert("סוג אימות לא ידוע");
			}
		},
		handleOnChange(value) {
			
			if (value.length < 6) {
				this.errorText = "";
			}
		},
		handleClearInput() {
			this.$refs.otpInput.clearInput();
		},
	},
	mounted() {
		this.$store.state.userLimitModal = false;
		this.$store.state.contactModal = false;

		this.$store.state.currentUser = this.decompressBase64Gzip(this.mixin_getCookie('user'));
		
		if (this.$store.state.currentUser != null) {
			this.$store.state.useremail = this.$store.state.currentUser.useremail;
		}

		else if (this.$store.state.useremail == null || this.$store.state.useremail == "") {
			if (this.mixin_getCookie("user") != null) {
				var decompessed = this.decompressBase64Gzip(this.mixin_getCookie("user"));
				if (decompessed != null) {
					this.$store.state.useremail = decompessed.useremail;
				}
			}
		}

		this.email = this.$store.state.useremail;
		
		if (this.$store.state.userTokenType == null) {
			if (sessionStorage.userTokenType != null) {
				this.$store.state.userTokenType = sessionStorage.userTokenType;
				
			}
		}
	},
	watch: {
		email() {
			this.$store.state.useremail = this.email;
			this.mixin_setCookie("useremail", this.email);
		},
	},
};
</script>

<style lang="less">
.otp-input {
	width: 40px;
	height: 40px;
	padding: 5px;
	margin: 0 10px;
	font-size: 20px;
	border-radius: 4px;
	border: 1px solid rgba(0, 0, 0, 0.3);
	text-align: center;
	&.error {
		border: 1px solid red !important;
	}
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
</style>
